/***************Enum Constants***************/

export enum AppEnv {
  Local = 'local',
  Dev = 'development',
  Stage = 'stage',
  QA = 'qa',
  Production = 'production'
}

export enum HttpHeader {
  ContentType = 'Content-Type',
  ApiKey = 'x-api-key',
  Token = 'access-token',
  Authorization = 'Authorization',
  CustomerShipTo = 'CustomerShipTo',
  loginShipToNumber = 'loginShipToNumber'

}

export enum HttpStatusCode {
  Timeout = 0,
  UnAuthorized = 401,
  BadRequest = 400,
  NotFound = 404,
  PreconditionRequired = 412,
  NoContent = 204
}

export enum Dashboard {
  DefautInterval = 30,
  AccountConfigurationTime = 1502,
  All = 1500,
  OrderTimes = 1501,
}




export enum ErrorNotificationType {
  Toast = 'TOASTER',
  Page = 'PAGE',
  Modal = 'MODAL',
}



export enum CacheDuration {
  Default = 60 * 60 * 2,
  OneMinute = 60 * 1,
  OneHour = 60 * 60 * 1,
  TwoHour = 60 * 60 * 2,
  OneDay = 24 * 60 * 60 * 1,
  SixHours = 60 * 60 * 6
}

export enum Configuration {
  API_KEY = 'apiKey',
  UNDER_MAITENANCE = 'appDown',
  INTERNAL_URL = 'userInternalUrl',
  APP_TIMEOUT = 'appIdleTimeout',
  API_TIMEOUT = 'apiTimeout',
  OKTA_ISSUER = 'oktaIssuer',
  OKTA_CLIENT_ID = 'oktaClient',
  OKTA_REDIRECT_URL = 'oktaRedirect',
  OKTA_LOGOUT_URL = 'oktaLogout',
  PRODUCTION_FLAG = 'production',
  APIGEE_ENDPOINT = 'apigeeTokenEndpoint',
  CONFIG_API_ENDPOINT = 'configUrl',
  CONTENT_API_ENDPOINT = 'contentUrl',
  CONTRACT_API_ENDPOINT = 'accountContractUrl',
  PRODUCT_API_ENDPOINT = 'productUrl',
  ACCOUNT_MGMT_API_ENDPOINT = 'accountMgmtUrl',
  USER_API_ENDPOINT = 'userUrl',
  VENDOR_CONTRACT_API_ENDPOINT = 'vendorContractUrl',
  ACCOUNT_PAYABLE_API_ENDPOINT = 'accountPayableUrl',
  ACCOUNT_RCV_API_ENDPOINT = 'accountRcvUrl',
  FUSION_API_ENDPOINT = 'fusionUrl',
  APIGEE_TOKEN_ENDPOINT = 'apigeeTokenEndpoint',
  FEE_INDEXING_JOB_API_ENDPOINT = 'userFeeIndexJobUrl',
  REPORT_API_ENDPOINT = 'reportUrl',
  AUTO_CONVERSION_API_ENDPOINT = 'autoConversionJobUrl',
}

export enum Module {

}

export enum LogLevel {
  TRACE = 'trace',
  DEBUG = 'debug',
  INFO = 'info',
  LOG = 'log',
  WARN = 'warn',
  ERROR = 'error',
}

export enum EncDecAlgo {
  AES = 'AES',
  DES = 'DES',
  TripleDES = 'TripleDES',
  RC4 = 'RC4',
  RC4Drop = 'RC4Drop',
  Rabbit = 'Rabbit',
  RabbitLegacy = 'RabbitLegacy',
  EvpKDF = 'EvpKDF',
}

export enum SignOutReason {
  Default = 1,
  Timeout = 2,
  SessionExpired = 3,
}

export enum SortDirections {
  Ascending = 'asc',
  Descending = 'desc',
}

export enum Pagination {
  DefaultPageNo = 1,
  DefaultPageSize = 10,
}

export enum AppEvents {
  ACCOUNT_CHANGED = 'ACCOUNT_CHANGED',
  DEFAULT_ACCOUNT_SELECTED = 'DEFAULT_ACCOUNT_SELECTED',
  DEFAULT_ACCOUNT_REMOVED = 'DEFAULT_ACCOUNT_REMOVED'
}

/***************Enum Constants***************/


export class AppConstant {
  static readonly Messages = {

    Schedule: {
      WOAlertHeader: "Look's like we are having some server issues",
      WOAlertMessage: "Unfortunately our Web Ordering service is unable to complete this action. We are looking into the issue. Please try again by refreshing your page after a couple of minutes",
      NoOrderingPhysician: "The ordering physician is missing. Please go to the Manage Procedure screen and select the ordering physician.",
      MultipleComponents: "The selected procedure contains more than one component which cannot be ordered together. Please go to settings and split the procedure.",
      AlternateProcedure: "The selected procedure cannot be scheduled for more than one patient at a time.",
      TimeSlotExpired: "The below time-slot has been expired. Please select a new slot.",
      BatchTitle: "Batch Schedule",
      ScheduleTitle: "Schedule Procedure",
      AddOrderTitle: 'Add Order',
      ReleaseSlot: "There is a hold on this time-slot.  Do you want to release it?",
      VerifySentOrdersFailed: "We couldn’t send the below order automatically. Please contact the pharmacy.",
      IsPastSpecialProductOrder: "The cutoff time for cancelation has been exceeded, the order cannot be canceled, would you like to still cancel the procedure?",
      ComponentCalTimeWarningMessage: "Components scheduled are not in ordered sequence of time. Please verify.",
      InActiveComponentSupplyMessage: "Procedure contains one or more inactive component/supply. Please reconfigure procedure",
      NoActiveComponentSupplyMessage: "No active component/supply for procedure. Please reconfigure procedure",
      CustomerSameDayCutOffMessage: "Customer same day cutoff time is exceeded. Please contact your Cardinal Health Pharmacy.",
      OrderPastCalibrationMessage: "Order cannot be placed for past calibration time.",
      UnsentOrderTitle: 'Unsent Orders',
      UnsentOrderWarningMessage: "There are unsent orders for date {{  this.currentDate | date: 'MM/dd/yyyy'}}. Do you want to send the orders ?",
      GA68SlotsErrMessage: 'An error has occurred. Please contact system administrator.',
      GA68SlotsErrMessage2 : "The server is taking too long to respond. This can be caused by either poor connectivity or an error with our servers. Please try again later.",
      PluvictoCancelOrder: "This product is not orderable"
    },
    Login: {
      Success: 'User has authenticated successfully.',
      Failed: 'User authentication was failed. Username: {username}, Error: {0}',
      UnAuthorized: 'User was authenticated successfully but unauthorized to access the application.',
      NotAllowedOnProd: 'Please use NPS User Management application for login.',
    },
    Logout: {
      Success: 'User \'\{0}\'\ has logged off successfully.',
      Timeout: 'User \'\{0}\'\ has logged off due to timeout activity.',
      SessionExpired: 'User \'\{0}\'\ has logged off due to session expired.'
    },
    SessionExpired: {
      Title: 'Session Expired',
      Message: 'Your session has expired. Please relogin.'
    },
    Offline: {
      Message: 'You are not connected to internet.'
    },
    User: {
      AssignRoleSuccess: 'Role has been assigned sucessfully',
      RemoveRoleSuccess: 'Role has been removed sucessfully',
      ResetPassword: 'Reset password link has been sent successfully',
      ResendActivation: 'Activation link has been sent successfully',
      SaveGroup: 'Group has been assigned successfully',
      RemoveGroup: 'Group has been removed successfully',
      PharmacyLocationSavedSuccesfully: "Pharmacy Preference Locations has been updated succesfully"
    },

    Aaa: {
      AaaConfigureSuccess: 'Accounts have been assigned successfully to AAA users',
      RemovedSuccessfully: 'Accounts have been removed successfully for AAA users',
      NoChangesToSave: 'There are no changes to save',
      NoSearchResult: 'No account found with entered search criteria',
      ConfirmAccountRemovalTitle: 'Confirm Delete Accounts',
      ConfirmAccountRemoval: 'Are you sure you want to remove the accounts assigned to the AAA users?',
      FixError: 'There is a problem with the details entered. Please fix the errors.',


    },

    Configuration: {
      DeleteComponentConfigurationConfirm:
        "<div class='component-const-message'>Deleting the component will also remove it from these procedures and/or recurring orders. This action cannot be reversed. Do you want to continue?",
      POExpiredMessage: "PO Number is expired. Please reconfigure.",
      DeleteComponentConfirm: "Are you sure you want to delete component '<b>",
      OrderingPhysicianInactiveMessage: "Ordering Physician is inactive.",
    },

    Digirad: {
      DigiradConfigureSuccess: 'Application Digirad Configured successfully!',
      MobileFacilityUpdateSuccess: 'Facility Updated successfully!',
      NoSearchResult: 'No account found with entered search criteria'
    },
    shipto: {
      ShipToRemovedSuccessfully: "Account has been removed successfully",
      XofigoAccountMappingSuccessfully: "Xofigo account has been mapped successfully",
      XofigoAccountMappingDeletedSuccessfully: "Xofigo account has been un-mapped successfully",
      AccountsSavedSuccessfully: 'Accounts have been saved successfully',
      RemoveShipToAccountTitle: "Confirm Delete Account",
      RemoveShipToAccountMessage: "Are you sure you want to remove nuctrac account?",
      FeaturesSavedSuccessfully: "Nuctrac features have been saved successfully.",
      StandingOrderSavedSuccessfully: "Monthly billing has been saved successfully",
      TrainingOrderPlacedSuccessfully: "Training order has been placed successfully",
      HardwareOrderPlacedSuccessfully: "Hardware order has been placed successfully",
      JobExecutedSuccessfully: "Monthly job has been executed successfully",
      OrderPlacementConfirmTitle: "Confirm Order Placement",
      OrderPlacedConfirmationMessage: "Are you sure you want to place this order?",
      IsLicenseAvailableTitle: "Error",
      IsLicenseAvailableMessage: "OTC01",
      SSOFlagEnabledSuccessFully: "Customer SSO preference has been changed successfully.",
      RETURNINVENTORYFlagEnabledSuccessFully: "Customer Return Inventory preference has been changed successfully.",
      SettingsFlag: "Customer SSO and Return Inventory preference has been changed successfully.",

    },
    AppMaintenance: {
      saveSuccess: 'Application Maintenance Configured successfully !'
    },
    deleteMaintenance: {
      deleteSuccess: 'Record Deleted Successfully !'
    },
    Orders: {
      PastDateOrder : 'OR001',
      PharmacyNotEnabledWebOrdering : "L001",
      PharmacyNotEnabledSameDayOrdering : "L002",
      PharmacyHoldiday:"L007",
      AccountNotEnabledWebOrdering : "A001",
      AccountNotEnabledSameDayOrdering : "A004",
      SameDayCutOffExceeded : "A003",
      ProductSameDayCutOffExceeded : "PRD003",
      ProductNotEnabledSameDayOrdering : "PRD002",
      ProductNotEnabledWebOrdering : "PRD006",
      ProductNotOrderableAtThisTime : "PRD009",
      ModificationRequestPendingMessage :'UIO004',
      CancelRequestPendingMessage :'UIO005',
      CancelCutOffStatusExceeded : "OR011",
      CancelShipTimeExceeded : "OR023",
      CancelCutOffTimeExceeded :"A007",
      ProductCancelCutOffTimeExceeded : "PRD005",
      CancelPastOrder : 'OR022',
      GetAccountDetailsFailure : 'UID006'
    },
    ReturnProduct:
    {
      returnSourceValue : 12122,
      ReturnOrderSuccessful : "Order return request/order return cancellation request has been successfully initiated.",
      ReturnOrderFailure: "Something went wrong! Could not complete request"
    },
    GenericErrorMessage:
      'An error has occurred  while processing your request. Please try again. If problem persist, contact customer service.',
    UnderMaintenance:
      'Site is temporarily unavailable, we are undergoing routine maintenance at this time.',

    AccountRoles : {
      NoRoleAssigned: 1,
      RolesAssigned: 2,
      OnlyInvoice: 4
    }
  };

  static readonly ExternalUrl = {
    CardinalHealth: 'https://www.cardinalhealth.com/en.html',
    Legal:
      'https://www.cardinalhealth.com/en/support/terms-and-conditions-english.html',
    PrivacyPolicy:
      'https://www.cardinalhealth.com/en/support/privacy-policy.html',
    ITAndSecurityControl:
      'https://www.cardinalhealth.com/en/support/compliance-reporting.html'
  };

  static readonly Formatter = {
    Authentication: '{0}',
    UserName: '{username}',
    TrackingIds: '{ids}'
  };

  static TypeGroups = { SearchUser: 23, DMSSoftware: 32, SLA: 33 };
  static TypeCodes = { NPSUserManagement: 4, LogOut: 1201, TimeOut: 1202 };

  static readonly Account = {
    Properties: {
      CustomerShipToNum: 'customerShipToNum',
      CustomerName: 'customerName',
      LocationNum: 'locationNum',
      CustomerMigrateToWO: 'isCustomerMigratedToNewWO',
      UserRoleList: 'userRoleXrefList'
    }
  }

  static readonly Preferences = {
    REMOVABLE_ACTIVITY: "1",
    PREVENT_ADMINISTRATION_IF_VARIANCE_IS_OUT_OF_RANGE: "2",
    ADMINISTRATION_VARIANCE_FROM_PRESCRIBED_AMOUNT: "3",
    USE_PHARMACY_CALIBRATION_AS_ASSAY: "4",
    NUMBER_OF_DOSE_LABEL_FOR_AUTO_PRINT: "5",
    AUTO_PRINT_PATIENT_SAFETY_CARDS: "6",
    ALLOW_24_HOUR_TIME_FORMAT: "7",
    DEFAULT_PATIENT_NAME: "8",
    ALLOW_LESS_THAN_ZERO_READINGS_IN_AREA_SURVERY_AND_WIPE_SURVEY_RESULTS: "9",
    BLOCK_RECEIVE_INVENTORY_OPTION_IF_INSTRUMENT_TESTS_HAVE_NOT_BEEN_RUN: "10",
    BLOCK_ASSAY_OR_DOSE_CMPONENT_IF_INSTRUMENT_TESTS_HAVE_NOT_BEEN_RUN: "11",
    PATIENT_WEIGHT_IN_UNITS_OF_LBS_OR_KG: "12",
    REQUIRE_DATE_OF_BIRTH: "13",
    REQUIRE_MRN: "14",
    REQUIRE_PATIENT_VISIT_ID: "15",
    NUMBER_OF_ELUTION_LABEL_FOR_AUTO_PRINT: "16",
    NUMBER_OF_INVENTORY_LABEL_FOR_AUTO_PRINT: "17",
    NUMBER_OF_KIT_LABEL_FOR_AUTO_PRINT: "18",
    NUMBER_OF_DAYS_BETWEEN_DUPLICATE_RX_NUMBERS_FOR_WARNING: "19",
    HIDE_WIPE_TEST_CONTENTS: "20",
    INCOMING_PACKAGE_SURVEY_REQUIRED: "21",
    INCOMING_PACKAGE_WIPE_REQUIRED: "22",
    DISABLE_WASTE_SYSTEM: "23",
    OUTGOING_PACKAGE_SURVEY_REQUIRED: "24",
    OUTGOING_PACKAGE_WIPE_REQUIRED: "25",
    DEFAULT_DISPOSAL_LOCATION_TEXT: "26",
    DISPLAY_DAYBOARD_SUMMARY_LARGE_NUMBERS: "28",
    AREA_WIPE_DEFAULT: "29",
    PACKAGE_BAR_DEFAULT: "30",
    CREATE_WASTE_BIN_AUTO: "31",
    WIPE_TEST_ACTION_LEVEL_DEFAULT: "32",
    WIPE_TEST_COUNT_DEFAULT: "33",
    PACKAGE_DOT_AREA_WIPE: '34',
    wasteBinStatus: '35',
    returnForCreditEnabled: '36',
    safeTracAlertOnAssay: '37',
    PATIENT_HEIGHT_IN_UNITS_OF_IN_OR_CM: '38',
    BATCH_SCHEDULE_PROCEDURE: '40',
    PATIENT_FIRSTNAME_LASTNAME: '42',
    ADMINISTRATION_TIME_ON_DOSING_SCREEN: '43',
    VENDOR_NAME_DEFAULT: '44',
    WIPE_AREA_DEFAULT_SIZE: '46',
    IN_HOUSE_OUTGOING_PACKAGE_WIPE_REQUIRED: '45',
    SHOW_INPUT_PATIENT_NAME_UPPERCASE: '48',
    SERILE_KIT_PREPARATION_AREA_EXTENDED_EXOIRY_TIME: '49',
    SORT_ORDER_DAYBOARD_SCHEDULE_SECTION: '50',
    DEFAULT_HOURS_TO_EXPIRE: '51',
    ADMINISTRATION_ROUTE_REQUIRED: '52',
    ADMINISTRATION_SITE_REQUIRED: '53',
    SHOW_NUCBOT_WIDGET: '54',
    AUTO_POPULATE: '55',
    SYSTEM_TIMEZONE: '56',
    WO_PARTICLE_COUNT_RANGE_DIFF: "WO_PARTICLE_COUNT_RANGE_DIFF",
    APP_VERSION: "WO_APP_VERSION",
    WO_VALIDATE_APP_VERSION: 'WO_VALIDATE_APP_VERSION',
    DMS_APP_URL: 'DMS_APP_URL',
    NEW_REJECT_NOTIFICATION_MODULE_FLAG:'NEW_REJECT_NOTIFICATION_MODULE_FLAG',
    SHOW_340B_ENTITY_VERIFICATION_FORM: 'SHOW_340B_ENTITY_VERIFICATION_FORM',
    Enable_SONEXUS_INTEGRATION:'SONEXUS INTEGRATION FLAG'
  }
}

export const AppMessages = {
  VersionMismatchMessageId : 'VRSN001',
};

export const Validation = {
};

export const TypeCode = { NPSWO: 1, SYNTRAC: 2, INVOICING: 3, UserRegistration: 4 };

export const MessageFormatter = {
  Limit: '{{limit}}',
  Item: '{{item}}',
  Total: '{{total}}',
  Date: '{{date}}',
};

export const Regex = {
  RestrictSpecialChars: /[^A-Za-z0-9:;<=>?\^{}|~!'#$%&'()*+,.`_@\-\[\]\/\\ ]/g,
  AllowNumericOnly: /^[0-9]*$/,
  Allow3DigitBefore2AfterDecimal: /^[0-9]{1,3}(?:\.[0-9]{1,2})?$/,
  Allow5DigitBefore5AfterDecimal: /^[0-9]{0,5}(?:\.[0-9]{1,5})?$/,
  Allow7DigitBefore5AfterDecimal: /^[0-9]{0,7}(?:\.[0-9]{1,5})?$/,
  AllowAlphaNumericOnlyWithSpaceSpecialChars: /^[a-zA-Z0-9 !"#$%&'()*+.,\/:;<=>?@\[\\\]^_{|}-]*$/,
  AlphabetsOnly: /^[A-Za-z ]*$/,
  AlphaNumericOnly: /^[a-zA-Z0-9 ]*$/,
  PatientVistIdRegex: /^[a-zA-Z0-9 -]*$/,
  Password:
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-!"#\$%\&'\(\)*+,./:;<=>\?@\[\]])(?=\S+$).{6,}$/,
  //Email: /.{1,}@.{1,}\..{1,}/,
  Email: /^[a-zA-Z0-9]+[a-zA-Z0-9.'_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z.]{2,15}$/,
  Link: /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
  Date: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/,
  //Date: /(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
  Time: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,

  MultipleEmail: /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4};?)+$/,
  NumericOnly: /^\d+$/,
  NumericGTZero: /^[1-9][0-9]*$/,
  Decimal: /^[0-9]+(\.[0-9]*){0,1}$/g,
  DecimalGTZero: /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/g,
  DecimalTwoScale: /^[0-9][0-9]*[.]?[0-9]{0,2}$/,
  DecimalThreeScale: /^[0-9][0-9]*[.]?[0-9]{0,3}$/,
  DecimalFourScale: /^[0-9]*[0-9]*[.]?[0-9]{0,4}$/,
  DecimalSixScale: /^[0-9][0-9]*[.]?[0-9]{0,6}$/,
  DecimalSixPrecisionFiveScale: /^\d{1,1}(\.\d{1,5})?$/,
  DecimalEightPrecisionFiveScale: /^\d{1,3}(\.\d{1,5})?$/,
  DecimalNegativeFourScale: /^[-][0-9][0-9]*[.]?[0-9]{0,4}$/,
  DecimalNegativeSixScale: /^-?[0-9][0-9]*[.]?[0-9]{0,6}$/,
};



export const _staticDataItems = { uoms: 'uoms', applicationPreferences: 'applicationPreferences', messages: 'messages', productTypes: 'productTypes', reasonRefs: 'reasonRefs', requestSources: 'requestSources', statRefs: 'statRefs', timezones: 'timezones', typeGroups: 'typeGroups', typeRefs: 'typeRefs' };
export const Messages = {
  GenericErrorMessage: "An error has occurred while processing your request. Please try again later.",
  PastDateOrder: 'OR001',
  PharmacyNotEnabledWebOrdering: "L001",
  PharmacyNotEnabledSameDayOrdering: "L002",
  AccountNotEnabledWebOrdering: "A001",
  AccountNotEnabledSameDayOrdering: "A004",
  SameDayCutOffExceeded: "A003",
  ProductSameDayCutOffExceeded: "PRD003",
  ProductNotEnabledSameDayOrdering: "PRD002",
  ProductNotEnabledWebOrdering: "PRD006",
  ProductNotOrderableAtThisTime: "PRD009",
  ModificationRequestPendingMessage: 'UIO004',
  CancelRequestPendingMessage: 'UIO005',
  CancelCutOffStatusExceeded: "OR011",
  CancelShipTimeExceeded: "OR023",
  CancelCutOffTimeExceeded: "A007",
  ProductCancelCutOffTimeExceeded: "PRD005",
  CancelPastOrder: 'OR022',
  CancelOrderConfirm: 'UIO001',
  OrderCancelRequestPending: 'UIO011',
  XofigoCancelFromWoMessage:
    'This procedure cannot be cancelled directly from WO. Please call Xofigo Access Services at 855.696.3446 option 1 to cancel the order.'

}


export const DateFormat = {
  Default: 'MM/DD/YYYY',
  MMDDYYYY: 'MM/DD/YYYY',
  MMDDYYYYHyphen: 'MM-DD-YYYY',
  YYYYMMDD: 'YYYY-MM-DD',
  DD: 'DD',
  MMDDYYYYHMMSS: 'MM/DD/YYYY HH:mm:ss',
  MMDDYYYYHMM: 'MM/DD/YYYY HH:mm',
  HHMM: 'HH:mm',
  HHMMA: 'HH:mm A',
  DMDY: 'dddd, MMMM D, YYYY',
  YYYYMMDDHHMMz: 'YYYY-MM-dd HH:mm z',
  YYYYMMDDTHHMMSS: 'YYYY-MM-DD[T]HH:mm:ss'
};

export const TypeCodes = {
  NPSWO: 1,
  bmi: 50,
  byWeightRange: 51,
  byWeight: 52,
  between: 100,
  greaterOrEqual: 101,
  kg: 151,
  lbs: 150,
  inch: 200,
  cm: 201,
  noScheduling: 250,
  weekDay: 251,
  dayOfMonth: 252,
  weekDayOfMonth: 253,
  logOut: 1201,
  timeOut: 1202
};

export const AccountTypes = { NPSWO: 1, Invoice: 3 };

export const OrderStatusTypes = {
  Unsent: 1,
  Sent: 2,
  Packaged: 4,
  Shipped: 8,
  Cancelled: 16
} as any;


export const DiscardOrderUpdateChanges = "discardOrderUpdateChanges";

export const UserProperties = {
  UserDetailNum: "userDetailNum",
  DefaultShipToNumber: "defaultShipToNumber",
  CustomerAccountsList: "customerAccountsList",
  InvoiceAccountsList: "invoiceAccountsList",
  UserRoleList: "userRoleXrefList",
  UserPreferences: "userPreferences",
  EmailId: "emailId"
};

export const Properties = {
  CustomerShipToNum: 'customerShipToNum',
  CustomerName: 'customerName',
  LocationNum: 'locationNum',
  CustomerMigrateToWO: 'isCustomerMigratedToNewWO'
};

export const OrderViewTypes = { All: 1500, OrderTimes: 1501, AccountConfigurationTime: 1502 };

export const OrderOriginalStatusCodes = {
  Sent: 100,
  Accepted: 200,
  Filled: 400,
  Packaged: 500,
  Dispatched: 600,
  Delivered: 700,
  EOD: 800,
  Invoiced: 900,
  Cancelled: 1200
};

export const AppData = {
  Name: 'App',
  Items: {
    IsServiceLoaded: 'IsServiceLoaded',
    AppLoaded: 'AppLoaded',
    SessionExpired: "SessionExpired",
    UpdateAvailable: "UpdateAvailable",
    CacheUpdated: "CacheUpdated",
    UserDetails: "UserDetails",
    DeviceDeatils: "DeviceDeatils",
    AccountDetails: "AccountDetails",
    Procedures: 'Procedures',
    RecurringOrders: 'RecurringOrders',
    OrderReport: "OrderReport"
  }
};

export const RoleCodes = { Buyer: 1, Admin: 2, ReadOnly: 3, AAA: 4, Invoice: 50 };

export const UnsentStatusCode = 5001;
export const ProdTypes = { DRG: 0, DVC: 1, SRVC: 2, OTH_SRVC: 3 };

export const Url = {
  RemoveOrderUrl: '/unsent',
  CancelOrderUrl: '/cancel',
}
export const OrderStatusCodes = {
  Unsent: 5150,
  Sent: 5151,
  Packaged: 5152,
  Shipped: 5153,
  Cancelled: 5154
} as any;


export const Sources = { NPSWO: 1, SYNTRAC: 2, MANUAL: 3, STANDING: 4, XOFIGO: 5 };

export const RequestStatusCodes = {
  Cancelled: 5005,
  Rejected: 5003,
  ModifyPending: 5051,
  CancelPending: 5055,
  Sent:5002,
  Unsent:5001
};

export const ErrorConfig = {
  SysErrId: 'SYS100', BadRequestId: 'SYS400', NotFoundId: 'SYS404',
  PreconditionRequiredId: 'SYS428', TimeoutId: 'UI408', MessageTypes: { Toastr: 'TOASTER', Page: 'PAGE', Modal: 'MODAL' }
};



export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

export const ProductTypes = { DRG: 0, DVC: 1, SRVC: 2, OTH_SRVC: 3 };
